import { useEffect, useState } from "react";
import { getNewsletterSubscribers, type NewsletterItem } from "@admin/lib/api";
import { formatDate } from "@admin/lib/utils";
import { Button } from "@admin/components/ui/button";

export default function NewsletterPage() {
  const [items, setItems] = useState<NewsletterItem[]>([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [err, setErr] = useState<string | null>(null);
  const limit = 50;

  useEffect(() => {
    setErr(null);
    getNewsletterSubscribers(limit, offset)
      .then((data) => {
        setItems(data.items);
        setTotal(data.total);
      })
      .catch(() => setErr("Could not load newsletter subscribers"));
  }, [offset]);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Newsletter ({total})</h1>
      {err && <p className="text-danger">{err}</p>}
      <div className="overflow-x-auto rounded-lg border border-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-muted/50 text-muted-fg">
            <tr>
              <th className="px-4 py-3 font-medium">Email</th>
              <th className="px-4 py-3 font-medium">Locale</th>
              <th className="px-4 py-3 font-medium">Source</th>
              <th className="px-4 py-3 font-medium">Country</th>
              <th className="px-4 py-3 font-medium">Signed up</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.id} className="border-b border-border last:border-0">
                <td className="px-4 py-3">{row.email}</td>
                <td className="px-4 py-3">{row.locale}</td>
                <td className="px-4 py-3">{row.source}</td>
                <td className="px-4 py-3">{row.signupCountry ?? "-"}</td>
                <td className="px-4 py-3 text-muted-fg">{formatDate(row.createdAt)}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-muted-fg">
                  No subscribers yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {total > limit && (
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            disabled={offset === 0}
            onClick={() => setOffset(Math.max(0, offset - limit))}
          >
            Previous
          </Button>
          <span className="text-sm text-muted-fg">
            {offset + 1}-{Math.min(offset + limit, total)} of {total}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={offset + limit >= total}
            onClick={() => setOffset(offset + limit)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
